<script setup lang="ts">
import type { HTMLAttributes, VNode } from 'vue'
import { cn } from '@/utils'

defineOptions({
  name: 'FaDivider',
})

const props = defineProps<{
  position?: 'start' | 'end'
  class?: HTMLAttributes['class']
}>()

const slots = defineSlots<{
  default?: () => VNode
}>()
</script>

<template>
  <div
    :class="cn('my-4 w-full flex-center whitespace-nowrap text-sm font-500 after:h-px after:w-full after:min-w-4 after:bg-border after:content-empty before:h-px before:w-full before:min-w-4 before:bg-border before:content-empty', {
      'before:flex-basis-0': position === 'start',
      'after:flex-basis-0': position === 'end',
      'gap-4': !!slots.default,
    }, props.class)"
  >
    <slot />
  </div>
</template>
